// extracted by mini-css-extract-plugin
export var dropdownIcon = "_p8-6";
export var imgContainer = "_p8-3";
export var menuIcon = "_p8-5";
export var pillWrapper = "_p8-2";
export var pillsContainer = "_p8-1";
export var subscriptionCard = "_p8-0";
export var subscriptionLogo = "_p8-4";